"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var styles = {
  "icon": "icon_1YNw5R"
}; 
require('./OverviewType.css');
var OverviewType = function OverviewType(_ref) {
  var typeAttributes = _ref.typeAttributes;
  var iconProps = {
    size: 's',
    className: styles.icon,
    isDecorative: true
  };
  return typeAttributes ? /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
    title: "Type",
    testId: "asset-type"
  }, typeAttributes.icon.id ? /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, iconProps, {
    name: typeAttributes.icon.id,
    isExternal: false
  })) : /*#__PURE__*/_react.default.createElement(_Icon.default, iconProps, /*#__PURE__*/_react.default.createElement(typeAttributes.icon)), typeAttributes.name) : null;
};
var _default = exports.default = OverviewType;
//# sourceMappingURL=OverviewType.js.map